import { render, staticRenderFns } from "./DropdownOptionsNfs.vue?vue&type=template&id=2f046d1e&scoped=true&"
import script from "./DropdownOptionsNfs.vue?vue&type=script&lang=js&"
export * from "./DropdownOptionsNfs.vue?vue&type=script&lang=js&"
import style0 from "./DropdownOptionsNfs.vue?vue&type=style&index=0&id=2f046d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f046d1e",
  null
  
)

export default component.exports